export default "__VITE_ASSET__39669f10__"